module.exports = __webpack_public_path__ + "img/tips-gear-icon.7c949e33.svg";